import React, { useState, useRef, useEffect } from "react";
import { useAddNewIshranaMutation,useUpdateIshranaMutation,useDeleteIshranaMutation,useGetAllIshraneQuery } from "../features/ishrana/ishranaApiSlice";
import { useGetAllNamirniceQuery } from "../features/Namirnice/namirniceApiSlice";

// Za tabelu
// U ovo loadujes sve ishrane ovako kako i pise a u manirnice loadujes sve idijeve jer front posle resava tako sto iz loadovanih naminica trazi id i tako dalje...
const initialIshrane = [
  { id: 1, naziv: "Veganska", komentar: "Bez proizvoda životinjskog porekla", namirnice: ['67163417251e1e9ab68dd8f4', '67163474251e1e9ab68dd8fb'] },
  { id: 2, naziv: "Bezglutenska", komentar: "Bez glutenskih proizvoda", namirnice: [2] },
];

//Loadujemo iz baze sve naminice
// const availableNamirnice = [
//   { id: 1, naziv: "Limun", grupa: "Voće", podtip: "Citrus", laktoza: false, gluten: false, alergen: false },
//   { id: 2, naziv: "Kikiriki", grupa: "Orašasti Plodovi", podtip: "Orašasti Plodovi", laktoza: false, gluten: false, alergen: true },
//   { id: 3, naziv: "Banana", grupa: "Voće", podtip: "Tropsko", laktoza: false, gluten: false, alergen: false },
//   { id: 4, naziv: "Šargarepa", grupa: "Povrće", podtip: "Korenito", laktoza: false, gluten: false, alergen: false },
//   { id: 5, naziv: "Celer", grupa: "Povrće", podtip: "Korenito", laktoza: false, gluten: false, alergen: false },
//   { id: 6, naziv: "Paskanat", grupa: "Povrće", podtip: "Korenito", laktoza: false, gluten: false, alergen: false },
// ];

// const grupisaneNamirnice = availableNamirnice.reduce((acc, namirnica) => {
//   if (!acc[namirnica.grupa]) {
//     acc[namirnica.grupa] = {};
//   }
//   if (!acc[namirnica.grupa][namirnica.podtip]) {
//     acc[namirnica.grupa][namirnica.podtip] = [];
//   }
//   acc[namirnica.grupa][namirnica.podtip].push(namirnica);
//   return acc;
// }, {});

const IshranaForm = () => {
  //U ovu promenljivu ishrane ja treba da stavim tabelu
  const [ishrane, setIshrane] = useState([]);
  const [nazivIshrane, setNazivIshrane] = useState("");
  const [komentar, setKomentar] = useState("");
  const [odabraneNamirnice, setOdabraneNamirnice] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editIshranaId, setEditIshranaId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const popupRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ishranaZaBrisanje, setIshranaZaBrisanje] = useState(null);
  const [IdIsh, setIdIsh] = useState(null);
  const [availableNamirnice, setAvailableNamirnice] = useState("");
  const [grupisaneNamirnice, setGrupisaneNamirnice] = useState("");

  //Hookovi
  const { isSuccess: isSuccessGetIsh, isError: isErrorGetIsh, error: getIshError, data: getIshData } = useGetAllIshraneQuery();
  const [addIsh, { isSuccess: isSuccessAddIsh, isError: isErrorAddIsh, error: errorAddIsh, data: dataAddIsh }] = useAddNewIshranaMutation();
  const [updateIsh, { isSuccess: isSuccessUpdateIsh, isError: isErrorUpdateIsh, error: errorUpdateIsh, data: dataUpdateIsh }] = useUpdateIshranaMutation();
  const [delIsh, { isSuccess: isSuccessDelIsh, isError: isErrorDelIsh, error: errorDelIsh, data: dataDelIsh }] = useDeleteIshranaMutation();

  //Za namirnice
  const { isSuccess: isSuccessGetNamir, isError: isErrorGetNamir, error: getNamirError, data: getNamirData } = useGetAllNamirniceQuery();

  //Get Ishrane
  useEffect(() => {
    if (isSuccessGetIsh) {
      // console.log("Success response:", Object.values(getCiljeviData.entities || {}));
      
      setIshrane(Object.values(getIshData.entities || []))

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetIsh) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getIshError?.data?.message
      alert(errorMessage);
    }
  }, [isSuccessGetIsh, isErrorGetIsh, getIshError, getIshData]);

  // useEffect(() => {
  //   console.log('first', ishrane)
  // }, [ishrane]);

  //Add Ishranu
  useEffect(() => {
    if (isSuccessAddIsh) {
      alert(dataAddIsh.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddIsh) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddIsh?.data?.message);
    }
  }, [isSuccessAddIsh, isErrorAddIsh, errorAddIsh, dataAddIsh]);

  //Update Ishranu
  useEffect(() => {
    if (isSuccessUpdateIsh) {
      alert(dataUpdateIsh.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorUpdateIsh) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorUpdateIsh?.data?.message);
    }
  }, [isSuccessUpdateIsh, isErrorUpdateIsh, errorUpdateIsh, dataUpdateIsh]);

  //Del prim cilj
  useEffect(() => {
    if (isSuccessDelIsh) {
      alert(dataDelIsh);
      // console.log('delleted', dataDelCilj)
    }
  
    if (isErrorDelIsh) {
      alert(errorDelIsh?.data?.message);
    }
  }, [isSuccessDelIsh, isErrorDelIsh, errorDelIsh, dataDelIsh]);

  //Get Namirnice
  useEffect(() => {
    if (isSuccessGetNamir) {
      // console.log("Success response:", Object.values(getCiljeviData.entities || {}));
      
      setAvailableNamirnice(Object.values(getNamirData.entities || {}));

      const grupisaneNamirnice_ = Object.values(getNamirData.entities || {}).reduce((acc, namirnica) => {
        if (!acc[namirnica.grupa]) {
          acc[namirnica.grupa] = {};
        }
        if (!acc[namirnica.grupa][namirnica.podtip]) {
          acc[namirnica.grupa][namirnica.podtip] = [];
        }
        acc[namirnica.grupa][namirnica.podtip].push(namirnica);
        return acc;
      }, {});

      setGrupisaneNamirnice(grupisaneNamirnice_)


    }

    if (isErrorGetNamir) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getNamirError?.data?.message
      alert(errorMessage);
    }
  }, [isSuccessGetNamir, isErrorGetNamir, getNamirError, getNamirData]);

  // const togglePopup = () => {
  //   setIsPopupOpen(!isPopupOpen);
  //   setErrorMessage(""); // Resetuj poruku o grešci pri otvaranju popupa
  // };
  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
    if (!isPopupOpen) {
      // Kada se popup otvori, setuj odabrane namirnice
      const allNamirnice = [];
      Object.values(grupisaneNamirnice).forEach(grupa => {
        Object.values(grupa).forEach(podtip => {
          allNamirnice.push(...podtip.map(namirnica => namirnica._id));
        });
      });
      setOdabraneNamirnice(allNamirnice); // Setuj sve namirnice kao odabrane
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validacija: Proveri da li je unet komentar i barem jedna namirnica
    if (komentar.trim() === "") {
      setErrorMessage("Komentar je obavezan.");
      return;
    }

    //Vrati posle kad uzveze namirnice
    // if (odabraneNamirnice.length === 0) {
    //   setErrorMessage("Morate izabrati barem jednu namirnicu.");
    //   return;
    // }

    const novaIshrana = {
      id: editIshranaId !== null ? editIshranaId : ishrane.length + 1,
      naziv: nazivIshrane,
      komentar,
      namirnice: odabraneNamirnice,
    };

    if (editIshranaId !== null) {
      
      if (!IdIsh || !komentar || !nazivIshrane) {
        alert("Molimo Vas unesite sve parametre");
        return;
      }
      // here
      try {
        await updateIsh({ IdIsh, komentar, nazivIshrane, odabraneNamirnice  });
      } catch (err) {
        console.error("Error occurred:", err);
      }

    } else {

      if (!komentar || !nazivIshrane) {
        alert("Molimo Vas unesite sve parametre");
        return;
      }
    
      try {
        await addIsh({ komentar, nazivIshrane, odabraneNamirnice });
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }

    setIsPopupOpen(false);
    resetForm();
  };

  const handleEdit = (id) => {
    const ishrana = ishrane.find((i) => i.id === id);
    if (ishrana) {
      setIdIsh(ishrana._id);
      setNazivIshrane(ishrana.naziv);
      setKomentar(ishrana.komentar);
      setOdabraneNamirnice(ishrana.namirnice);
      setEditIshranaId(id);
      setIsPopupOpen(true);
    }
  };

  const resetForm = () => {
    setNazivIshrane("");
    setKomentar("");
    setOdabraneNamirnice([]);
    setEditIshranaId(null);
    setErrorMessage("");
  };

  // const handleNamirnicaChange = (e) => {
  //   const namirnicaId = parseInt(e.target.value);
  //   setOdabraneNamirnice((prev) =>
  //     prev.includes(namirnicaId)
  //       ? prev.filter((id) => id !== namirnicaId)
  //       : [...prev, namirnicaId]
  //   );
  // };

  const handleNamirnicaChange = (event) => {
    const value = event.target.value;
    setOdabraneNamirnice((prev) => {
      if (prev.includes(value)) {
        return prev.filter((id) => id !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  const initializeOdabraneNamirnice = () => {
    const allNamirnice = [];
    Object.values(grupisaneNamirnice).forEach((grupa) => {
      Object.values(grupa).forEach((podtip) => {
        allNamirnice.push(...podtip.map(namirnica => namirnica._id));
      });
    });
    setOdabraneNamirnice(allNamirnice);
  };

  // useEffect(() => {
    // console.log('Odabrane naminice: ', odabraneNamirnice);
    // console.log('Avlible: ', availableNamirnice);

  // }, [odabraneNamirnice]);

  const handleDelete = (id) => {
    let ishr = ishrane.find((n) => n.id === id);
    setIdIsh(ishr._id);
    setIsModalOpen(true);
  };

  const handleConfirmDelete = async () => {

    if(!IdIsh){
      alert("Potreban je ID ishrane");
    }

    try {
      await delIsh({ id: IdIsh });
    } catch (err) {
      console.error("Error occurred:", err);
    }

    setIsModalOpen(false);
    setIshranaZaBrisanje(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIshranaZaBrisanje(null);
  };

  // Zatvaranje popup-a klikom van njega
  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsPopupOpen(false);
    }
  };

  useEffect(() => {
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  // const getNamirnicaNazivById = (id) => {
  //   const namirnica = availableNamirnice?.find((n) => n._id === id);
  //   return namirnica
  //     ? `${namirnica.naziv} ${
  //         namirnica.alergen ? "(Alergen)" : namirnica.gluten ? "(Sadrži Gluten)" : namirnica.laktoza ? "(Sadrži Laktozu)" : ""
  //       }`
  //     : "";
  // };
  const getNamirnicaNazivById = (id) => {
    if (!Array.isArray(availableNamirnice)) {
      console.error("availableNamirnice is not an array");
      return "";
    }
  
    const namirnica = availableNamirnice.find((n) => n._id === id);
    return namirnica
      ? `${namirnica.naziv} ${
          namirnica.alergen ? "(Alergen)" : namirnica.gluten ? "(Sadrži Gluten)" : namirnica.laktoza ? "(Sadrži Laktozu)" : ""
        }`
      : "";
  };

  //Checkboxovi
  const data = [  //Data su specificni ciljevi
    {
        "_id": "671b4c6c7f23222dace0d139",
        "naziv": "Novi kombi max",
        "namirnice": [
            { "_id": "67178d15782070c626c8383f", "naziv": "Malina" },
            { "_id": "67178da9782070c626c8385d", "naziv": "Šargarepa" },
            { "_id": "67178dc0782070c626c83865", "naziv": "Krompir" },
            { "_id": "67178dfc782070c626c83871", "naziv": "Lešnik" },
            { "_id": "67179edc47f943393a28d0b7", "naziv": "Šećer" },
            { "_id": "6717c4f9dcde0ddee8cb20fb", "naziv": "Ananas" },
            { "_id": "6717d9c9170ab064a200fbfa", "naziv": "Susam" },
            { "_id": "67178d05782070c626c8383b", "naziv": "Jagoda" },
            { "_id": "67178cf6782070c626c83837", "naziv": "Manadrina" },
            { "_id": "67178cc0782070c626c8382b", "naziv": "Nazrandža" },
            { "_id": "67178d60782070c626c8384f", "naziv": "Blitva" },
            { "_id": "67178ce6782070c626c83833", "naziv": "Grejpfrut" }
        ]
    },
    {
        "_id": "671b4ee5fd17aae4e3ac9a59",
        "naziv": "YYyY",
        "namirnice": [
            { "_id": "67178d60782070c626c8384f", "naziv": "Blitva" },
            { "_id": "67178d15782070c626c8383f", "naziv": "Malina" },
            { "_id": "67178d3a782070c626c83847", "naziv": "Kupina" },
            { "_id": "67178d73782070c626c83853", "naziv": "Kelj" }
        ]
    },
    {
        "_id": "671b5468fd17aae4e3ac9aa4",
        "naziv": "List",
        "namirnice": [
            { "_id": "67178cc0782070c626c8382b", "naziv": "Nazrandža" },
            { "_id": "67178cf6782070c626c83837", "naziv": "Manadrina" },
            { "_id": "6719fd3232c617b42f16f9cd", "naziv": "Ribizla" }
        ]
    },
    {
        "_id": "671b5543fd17aae4e3ac9aa8",
        "naziv": "Vege1",
        "namirnice": [
            { "_id": "6717d9b5170ab064a200fbf4", "naziv": "Kuglice" },
            { "_id": "67178d05782070c626c8383b", "naziv": "Jagoda" },
            { "_id": "6717c4f9dcde0ddee8cb20fb", "naziv": "Ananas" }
        ]
    }
];



const [checkedItems, setCheckedItems] = useState({});
const [selectedNamirnica, setSelectedNamirnica] = useState('');
const [selectedIds, setSelectedIds] = useState([]); // Za čuvanje ID-jeva

// Prikupljanje svih naziva namirnica
const allNamirnice = Array.from(new Set(data.flatMap(item => item.namirnice.map(n => n.naziv))));

const handleCheckboxChange = (id) => {
    const newCheckedItems = {
        ...checkedItems,
        [id]: !checkedItems[id]
    };
    setCheckedItems(newCheckedItems);

    // Ažuriranje ID-jeva
    setSelectedIds(Object.keys(newCheckedItems).filter(key => newCheckedItems[key]));
};

const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedNamirnica(selectedValue);
    console.log('Selected naminica:', selectedValue)

    // Resetovanje checkboxova
    const newCheckedItems = {};
    if (selectedValue) {
        data.forEach(item => {
            const hasNamirnica = item.namirnice.some(n => n.naziv === selectedValue);
            newCheckedItems[item._id] = hasNamirnica;
        });
    }

    setCheckedItems(newCheckedItems);
    // Ažuriranje ID-jeva
    setSelectedIds(Object.keys(newCheckedItems).filter(key => newCheckedItems[key]));
};

  return (
    <div>
      {/* Dugme za kreiranje nove ishrane */}
      <div className="flex justify-end">
        <button onClick={togglePopup} className="mt-3 mx-3 bg-indigo-500 text-white py-2 px-4 rounded-lg hover:bg-indigo-600">Kreiraj Ishranu</button>
      </div>

      {/* Modal za potvrdu brisanja */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
            <div className="mt-3 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                <svg
                  className="h-6 w-6 text-yellow-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                Upozorenje
              </h3>
              <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-500">
                  Da li ste sigurni da želite izbrisati ovu ishranu?
                </p>
              </div>
              <div className="items-center px-4 py-3">
                <button
                  onClick={handleConfirmDelete}
                  className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                >
                  Da
                </button>
                <button
                  onClick={closeModal}
                  className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  Ne
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tabela sa kreiranim ishranama */}
      <div className="overflow-auto max-h-96 mt-6">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-100 sticky top-0">
            <tr>
              <th className="px-4 py-2 border">Naziv</th>
              <th className="px-4 py-2 border">Komentar</th>
              {/* <th className="px-4 py-2 border">Namirnice</th> */}
              <th className="px-4 py-2 border">Akcije</th>
            </tr>
          </thead>
          <tbody>
          {isErrorGetIsh ? (
            <tr>
              <td colSpan={4} className="px-4 py-2 text-center text-red-500">
                {getIshError?.data?.message || "Došlo je do greške."}
              </td>
            </tr>
          ) : isSuccessGetIsh ? (
            ishrane.map((ishrana) => (
              <tr key={ishrana._id}>
                <td className="px-4 py-2 border">
                  <button
                    onClick={() => handleEdit(ishrana._id)}
                    className="text-indigo-600 font-bold hover:underline"
                  >
                    {ishrana.naziv}
                  </button>
                </td>
                <td className="px-4 py-2 border">{ishrana.komentar}</td>
                {/* <td className="px-4 py-2 border">
                  <ul> */}
                    
                    {/* Ove naminice su vertikalno nabrojane */}
                    {/* {ishrana.namirnice.map((id) => (
                      <li key={id}>{getNamirnicaNazivById(id)}</li>
                    ))} */}
                    
                    {/* Ove naminice su horizontalno nabrojane */}

                    {/* {ishrana.namirnice.map((id) => getNamirnicaNazivById(id)).join(", ")}
                  </ul>
                </td> */}
                <td className="px-4 py-2 border text-center">
                  <button
                    onClick={() => handleDelete(ishrana._id)}
                    className="text-red-500 font-bold"
                  >
                    Izbriši
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="px-4 py-2 text-center">
                Nema dostupnih ishrana.
              </td>
            </tr>
          )}
        </tbody>

        </table>
      </div>

      {/* Popup forma */}
      {isPopupOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg z-50 max-w-md w-full max-h-screen overflow-y-auto" ref={popupRef}>
            <h2 className="text-xl font-bold mb-4">Kreiraj/Izmeni Ishranu</h2>
            <form onSubmit={handleSubmit}>
              {/* Naziv Ishrane */}
              <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">
                  Naziv Ishrane: <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={nazivIshrane}
                  onChange={(e) => setNazivIshrane(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg"
                  required
                />
              </div>

              {/* Komentar */}
              <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">Komentar:</label>
                <textarea
                  value={komentar}
                  onChange={(e) => setKomentar(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg"
                  rows="3"
                ></textarea>
              </div>

              {/* Poruka o grešci */}
              {errorMessage && (
                <div className="mb-4 text-red-500 font-bold">
                  {errorMessage}
                </div>
              )}

              {/* Odabir Namirnica */}
              {/* IMAJ U VIDU OVAJ DEO KODSA JER STRUKTUIRA GRUPE NAMIRNICE I PODTIPOVE !!! POSTAVI I CONDITIONAL !!! */}
              <div className="mb-4">
                <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>
                <div className="overflow-y-scroll" style={{ maxHeight: "400px" }}>
                  {Object.keys(grupisaneNamirnice).map((grupa) => (
                    <div key={grupa} className="mb-4">
                      <h3 className="text-lg font-semibold">{grupa}</h3>
                      {Object.keys(grupisaneNamirnice[grupa]).map((podtip) => (
                        <div key={podtip} className="ml-4 mb-2">
                          <h4 className="text-md font-medium">{podtip}</h4>
                          <div className="ml-6">
                            {grupisaneNamirnice[grupa][podtip].map((namirnica) => (
                              <div key={namirnica._id} className="flex items-center mb-1">
                                <input
                                  type="checkbox"
                                  value={namirnica._id}
                                  checked={odabraneNamirnice.includes(namirnica._id)}
                                  onChange={handleNamirnicaChange}
                                  className="mr-2"
                                />
                                <label>
                                  {namirnica.naziv}{" "}
                                  {namirnica.alergen ? "(Alergen)" : namirnica.gluten ? "(Sadrži Gluten)" : namirnica.laktoza ? "(Sadrži Laktozu)" : ""}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-indigo-500 text-white py-2 px-4 rounded-lg hover:bg-indigo-600"
              >
                Sačuvaj Ishranu
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Checkboxovi */}
      {/* <div className="p-4">
            <div className="mb-4">
                <label htmlFor="namirnica-select" className="block font-bold">Izaberi namirnicu:</label>
                <select
                    id="namirnica-select"
                    value={selectedNamirnica}
                    onChange={handleSelectChange}
                    className="mt-1 block w-full p-2 border border-gray-300 rounded"
                >
                    <option value="">Sve namirnice</option>
                    {allNamirnice.map(namirnica => (
                        <option key={namirnica} value={namirnica}>{namirnica}</option>
                    ))}
                </select>
            </div>

            <div>
                {data.map(item => (
                    <label key={item._id} className="flex items-center mb-2">
                        <input
                            type="checkbox"
                            checked={checkedItems[item._id] || false}
                            onChange={() => handleCheckboxChange(item._id)}
                            className="form-checkbox h-5 w-5 text-blue-600"
                        />
                        <span className="ml-2">{item.naziv}</span>
                    </label>
                ))}
            </div>

      
            <div className="mt-4">
                <h3 className="font-bold">ID-jevi checkiranih checkboxova:</h3>
                <pre>{JSON.stringify(selectedIds, null, 2)}</pre>
            </div>
        </div> */}



    </div>
  );
};

export default IshranaForm;
